import dayjs from "dayjs";
import { checkSnils, checkEmail, checkEAN13 } from "./utils";

export const isRequired = (value: any) => value && value.toString() ? false : 'Необходимо заполнить поле';

export const isSnils = (value: any) => checkSnils(value) ? false : 'Не верный СНИЛС';

export const isEmail = (value: string) => !value || checkEmail(value) ? false : 'Введите корректный адрес электронной почты';

export const isRus = (value: string) => !value || /^[а-яёА-ЯЁ\- ]+$/.test(value) ? false : 'Можно использовать только символы русского алфавита';

export const isNumber = (value: string) => !value || /^[0-9-]+$/.test(value) ? false : 'Можно использовать только цифры и дефис';

export const isYear = (value: number) => value >= 1900 && value <= 2100 ? false : 'Укажите правильный год';

export const isCorrectDate = (value: any) => !value || (dayjs(value).year() >= 1900 && dayjs().isAfter(value)) ? false : 'Введите корректную дату';

export const isCorrectGLN = (value: string) => !value || checkEAN13(value) ? false : 'Введите корректный GLN';
export const isCorrectPercent = (value: number) => value >= 100 && value <= 0 ? false : 'Значение не может быть больше 100% и 0%';
